import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";

const CreateUsers = ({ uploadData, onReset, onUpload, isCreating }) => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        marginBottom={"20px"}
      ></Box>

      {uploadData.data.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {uploadData.previewData[0].map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {uploadData.previewData.slice(1).map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex}>{cell}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Box display="flex" justifyContent="space-around" marginTop={"1.5rem"}>
        <CoreButton
          className={"btn-round-outline"}
          variant="outlined"
          onClick={onReset}
          testo="Reset"
          disabled={isCreating}
        />
        <CoreButton
          className={"btn-round"}
          variant="contained"
          onClick={onUpload}
          testo="Upload"
          disabled={isCreating}
        />
      </Box>
    </>
  );
};

export default CreateUsers;
